import { Card, CardContent } from '../components/ui/card';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const faqs = [
  { q: "How do I become a member?", a: "Visit our Membership page to learn about options and apply online. We offer Basic (free), Select ($99/year), and Founder ($999/lifetime) membership tiers." },
  { q: "What are the membership fees?", a: "Basic membership is free. Select membership is $99/year with auto-renewal. Founder membership is a one-time $999 lifetime payment." },
  { q: "How do I access member resources?", a: "Log in to your member dashboard to access all resources, events, and news. These are exclusive to registered members." },
  { q: "Can I cancel my membership?", a: "Yes, you can cancel anytime. Contact us at hello@americanrea.com for assistance with cancellations or changes." },
  { q: "What benefits do members receive?", a: "Members get access to exclusive resources, networking events, industry news, the member directory, and our community forum." },
  { q: "How do I update my profile information?", a: "Log in to your dashboard and navigate to the Profile section to update your information, including your license details and brokerage information." },
];

export default function FAQ() {
  return (
    <div className="bg-white" data-testid="faq-page">
      {/* Hero Section */}
      <section className="py-20 md:py-28 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl text-center">
          <span className="text-[#D42B3C] font-semibold text-sm tracking-wider uppercase mb-4 block">
            Support
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Find answers to common questions about AREA membership and services.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 md:py-28 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="grid grid-cols-1 gap-6">
            {faqs.map((faq, index) => (
              <Card key={index} className="border border-slate-200 shadow-lg bg-white">
                <CardContent className="p-6">
                  <h3 className="font-semibold text-slate-900 mb-3 text-lg">{faq.q}</h3>
                  <p className="text-slate-600">{faq.a}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Still have questions */}
          <div className="mt-16 text-center">
            <h2 className="font-heading text-2xl font-bold text-slate-900 mb-4">
              Still have questions?
            </h2>
            <p className="text-slate-600 mb-6">
              Can't find what you're looking for? Our team is here to help.
            </p>
            <Link to="/contact">
              <Button className="bg-[#3D4F7A] hover:bg-[#2A3755] text-white">
                Contact Us
                <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
